import { createAxiosHttp } from "./createHttpRequest";

type IResult<T> = {
  code: number;
  message?: string;
  data: T
}

//获取参与者的中心下拉接口
export const getCenterByProjectId = <T>(projectId: number)=> {
  return createAxiosHttp<IResult<T>>({
    method: 'POST',
    url: '/project/center/center/select',
    data: {
      projectId
    }
  })
}

// 受试者转移数据查询
export const subjectTransferQuery = <T>(userCode: string, centerId: number, projectId: number) => {
  return createAxiosHttp<IResult<T>>({
    url: `project/user/query/${userCode}/${centerId}/${projectId}`,
  })
}

// 转移受试者到
type TransoutSubjectParams = {
  projectId: number;
  centerId: number;
  transferCode: string;
  recipientCode: string;
  totalSubjects: number;
  subjectCodes: string[];
}
export const transoutSubject = <T>(params: TransoutSubjectParams)=> {
  return createAxiosHttp<IResult<T>>({
    method: 'POST',
    url: '/project/user/subject/transferSingle',
    data: params
  })
}